export default __webpack_public_path__ + "static/media/design_center.05349e64.png";